// extracted by mini-css-extract-plugin
export default {"description":"howBudgetExpenses_description__sRPoN"};